import React, { PureComponent } from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import fp from 'lodash/fp';
import { mapState, color } from '@deerplusofficial/pos-helper';
import { Button, Alert, Spinner, Icon } from '@deerplusofficial/pos-components';
import { connect } from 'react-redux';
import { withCheckout } from '../../model/Mutations';
import ScannerSelector, {
  scannerTypes,
} from '../ScannerSelector/ScannerSelector';
import SideInfoContainer from './SideInfoContainer';

const ScannerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  margin-top: 20px;
`;

const ScannerIcon = styled(Icon)`
  margin: 24px auto 10px;
  color: ${color.primary};
`;

class PaymentsTab extends PureComponent {
  componentDidMount() {
    const { scanner } = this.props;

    if (!_.isNil(scanner.type)) return;

    this.onScannerTypesShow();
  }

  onScannerTypesShow = () =>
    Alert.fire({
      title: '請選擇掃碼器類型',
      html: <ScannerSelector />,
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton: false,
      showCancelButton: !_.isNil(this.props.scanner.type),
    });

  onSubmit = async data => {
    if (!data) return;

    const { onCheckout, meta } = this.props;
    // TODO: 之後需要依照點選結帳的方式來取得 meta 裡的 id
    const methodId = _.get(...meta, 'id');

    await onCheckout({ methodId, token: data });
  };

  renderScanner = () => {
    const {
      member: { showModal },
      scanner: { type },
    } = this.props;

    if (_.isNil(type)) return null;

    const { icon, scanner: Scanner } = _.find(scannerTypes, { type });

    return (
      <React.Fragment>
        {!showModal && <Scanner onDetect={this.onSubmit} />}
        <ScannerIcon icon={icon} size="3x" />
        <Button link onClick={this.onScannerTypesShow}>
          變更掃碼器
        </Button>
      </React.Fragment>
    );
  };

  render() {
    const {
      order: { submitting },
    } = this.props;
    return (
      <SideInfoContainer>
        <ScannerContainer>
          {submitting ? <Spinner dark /> : this.renderScanner()}
        </ScannerContainer>
      </SideInfoContainer>
    );
  }
}

export default fp.compose(
  withCheckout(),
  connect(mapState(['scanner', 'order', 'member']))
)(PaymentsTab);



// WEBPACK FOOTER //
// ./src/components/CheckoutPanel/PaymentsTab.js